import {
    Component, AfterViewInit, OnChanges, ViewEncapsulation, HostListener, ViewChild, ElementRef, Input, Output, EventEmitter
} from '@angular/core';
import { trigger, state, style, transition, animate, group } from '@angular/animations';
import { CfaMenuItem } from '../tabs/cfa-menu-item';
import { CfaTab } from '../tabs/cfa-tab';
import { Subject } from 'rxjs';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cfa-hamburger-menu',
    templateUrl: './hamburger-menu.html',
    styleUrls: ['../../styles/styles.scss', './hamburger-menu.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('menuState', [
            state('inactive', style({
                'pointer-events': 'none',
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            transition('inactive => active', group([
                animate('100ms linear', style({ opacity: 1 })),
                animate('120ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'scale(1)' })),
            ])),
            transition('active => inactive', animate('100ms 25ms linear', style({ opacity: 0 })))
        ]),
        trigger('menuBackdropState', [
            state('void', style({
                'pointer-events': 'none',
                opacity: 0
            })),
            transition('void => active', group([
                animate('100ms linear', style({ opacity: 1 }))
            ])),
            transition('active => void', animate('100ms 25ms linear', style({ opacity: 0 })))
        ]),
        trigger('openChildTabState', [
            state('void', style({
                'pointer-events': 'none',
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            transition('void => active', group([
                animate('100ms linear', style({ opacity: 1 })),
                animate('120ms cubic-bezier(0, 0, 0.2, 1)', style({ transform: 'scale(1)' }))
            ]))
        ])
    ]
})
// tslint:disable-next-line:component-class-suffix
export class CfaHamburgerMenu implements AfterViewInit, OnChanges {

    @Input() useMaterialTheme = false;
    @Input() showDropShadow = false;
    @Input() expandHamburgerMenu = false;
    @Output() expandHamburgerMenuChange = new EventEmitter<boolean>();
    @Input() cfaTabs: CfaTab[] = [];
    @Input() cfaMenuItems: CfaTab[] = [];
    @Input() userName: string;
    @Output() homeClicked = new Subject<void>();
    @Output() signOutClicked = new Subject<void>();

    @Input() elementToIgnoreClicks: string;

    @ViewChild('hamburgerMenu') hamburgerMenu: ElementRef;

    constructor() { }

    ngAfterViewInit() { }

    ngOnChanges() { }

    private closeExpandedTabs(tab?: CfaTab) {
        this.cfaTabs.forEach(t => {
            if (t !== tab) {
                t.expanded = false;
            }
        });
    }

    selectTab(event: Event, tab: CfaTab, expand?: boolean) {
        if (event.defaultPrevented) {
            return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        this.closeExpandedTabs(tab);
        if (expand) {
            tab.expanded = !tab.expanded;
        }
        if (!tab.childTabs || tab.childTabs.length === 0) {
            this.closeMenu();
            tab.selected.next();
        }
    }

    selectMenuItem(menuItem: CfaMenuItem) {
        this.closeMenu();
        menuItem.selected.next();
    }

    clickSignOut() {
        this.closeMenu();
        this.signOutClicked.next();
    }

    clickHome() {
        this.closeMenu();
        this.homeClicked.next();
    }

    private closeMenu() {
        this.expandHamburgerMenu = false;
        this.expandHamburgerMenuChange.next(false);
    }

    @HostListener('document:click', ['$event'])
    handleDocClick(event) {
        if (this.containedWithinIgnorableElement(event.target)) {
            return;
        }
        if (this.hamburgerMenu && !this.hamburgerMenu.nativeElement.contains(event.target)) {
            this.closeMenu();
        }
    }

    private containedWithinIgnorableElement(element: HTMLElement): boolean {
        if (element.id === this.elementToIgnoreClicks) {
            return true;
        } else if (element.parentElement) {
            return this.containedWithinIgnorableElement(element.parentElement);
        }
    }
}
